import React, { useContext } from 'react'
import { RootContext as store } from '~/state'
import { locate } from '~/utils'
import { Clipboard } from '../icons'

export const FlowSelectControl = (): JSX.Element => {
  const { meta, setFlow } = useContext(store)

  const { main, subFlows } = meta?.recipe
    ? locate.recipeEntrypoint(meta?.recipe.flow)
    : { main: undefined, subFlows: [] }

  const options = main
    ? [main, ...subFlows].map((flow) => {
        return (
          <button
            key={`option-${flow.name}`}
            className={`flow-select-option ${
              meta?.activeFlow?.name === flow.name ? 'flow-select-option--selected' : ''
            }`}
            onClick={() => setFlow(flow.name)}
          >
            {flow.name}
            <style jsx>{`
              .flow-select-option {
                height: 20px;
                margin-left: 8px;
                font-family: 'Inter', sans-serif;
                border: none;
                border-radius: 20px;
                background: #fff;
                border: 1px solid #dadada;
              }

              .flow-select-option--selected {
                background: #dadada;
              }

              .flow-select-option:hover {
                background: #dadada;
              }
            `}</style>
          </button>
        )
      })
    : []

  return (
    <div className="flow-select">
      <Clipboard mode="dark" filled={false} />
      {options}
      <style jsx>{`
        .flow-select {
          height: 24px;
          margin-bottom: 8px;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
      `}</style>
    </div>
  )
}
